import React from "react";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import DraggableColumnRow from "./DraggableColumnRow";

interface Props {
  rows: any[];
  headers: any[];
  onChangeRows: (indexA: number, indexB: number) => void;
}

const COLUMN_SIZE = 5;

const DraggableColumnTable: React.FC<Props> = ({
  rows,
  headers,
  onChangeRows,
}) => {
  const chunkRows = (rows: any[], size: number) => {
    const chunks = [];
    for (let i = 0; i < rows.length; i += size) {
      chunks.push(rows.slice(i, i + size));
    }
    return chunks;
  };
  const columns = chunkRows(rows, COLUMN_SIZE);
  const onDragEnd = (result: any) => {
    if (!result.destination) return;

    const sourceCol = Number(result.source.droppableId);
    const destCol = Number(result.destination.droppableId);

    const sourceIndex = sourceCol * COLUMN_SIZE + result.source.index;

    const destIndex = destCol * COLUMN_SIZE + result.destination.index;

    onChangeRows(sourceIndex, destIndex);
  };

  return (
    <div style={{ height: "100%" }}>
      <div
        className="health-tt"
        style={{
          fontSize: "14px",
          position: "fixed",
          height: "30px",
          width: "100%",
        }}
      >
        {headers[0].content}
      </div>
      <DragDropContext onDragEnd={onDragEnd}>
        <div
          style={{ display: "flex", width: "max-content", padding: '30px 0px 0px' }}
        >
          {columns.map((columnRows, columnIndex) => (
            <Droppable droppableId={String(columnIndex)} key={columnIndex}>
              {(provided) => (
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    flex: "1",
                  }}
                >
                  {columnRows.map((row, index) => (
                    <DraggableColumnRow
                      key={row.id}
                      data={row}
                      index={index}
                      headers={headers}
                    />
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          ))}
        </div>
      </DragDropContext>
    </div>
  );
};

export default DraggableColumnTable;
